import { requests } from "../config";
import { IScalesResponse } from "./models/scalesResponse";

export const EXTERNAL = {
  getWeightFromScales: (numScales: string): Promise<IScalesResponse> => requests.get(`weight/${numScales}`, 'go')
}